import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from "recompose";
import {RESOURCES as combinedResources} from '../fuseCombinedSalesReportsResourceMap';
import {displayDateRangeString, sortArrayByKey} from '../shared/functions';
import {getGetHeaders, getPostHeaders} from '../shared/serverFunctions';
import CombinedSalesReportLocationsTable from './CombinedSalesReportLocationsTable';
import CombinedSalesReportSummaryTable from './CombinedSalesReportSummaryTable';
import RenderReport from './RenderReport';
import CircularProgress from 'material-ui/CircularProgress';
import {assembleReportPayload} from '../shared/reportFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import Config from '../messages';

const headerLocationObj = {
    address: null,
    city: null,
    city_limits: false,
    close_transfer_warehouse: null,
    dba: {
        id: null,
        name: null
    },
    district: {
        id: null,
        name: null
    },
    id: null,
    isOpen: false,
    latitude: null,
    location_type: {
        name: null
    },
    longitude: null,
    lot_notes: null,
    name: null,
    price_level: null,
    state: null,
    telephone: null,
    zipcode: null,
};

/**
 * Class for retrieving Sales Summary data for multiple tables
 *
 */
class CombinedSalesReportSet extends Component {
    constructor(props) {
        super(props);
        const headerLocation = JSON.parse(JSON.stringify(headerLocationObj));
        this.state = {
            allowLocationSelection: true,
            dataIsFiltered: false,
            dataSet1Complete: false,
            dataSet2Complete: false,
            errorMessageSummary: null,
            errorMessageLocation: null,
            headerLocation: headerLocation,
            loadingData1: props.showLoading,
            loadingData2: false,
            payload: assembleReportPayload(),
            reportName: 'Combined Sales',
            selectedLocation: {
                id: null,
                name: null,
                dba_name: null,
                city: null,
                selected: false,
                state: null,
                type: null,
                zipcode: null
            },
            tableSetLocationDaily: [],
            tableSetLocationTotal: [],
            tableSetLocations: [],
            tableSetSummary: []
        };
        this.area2Position = null;
        this.assemblePayload = this.assemblePayload.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
    }

    componentWillMount() {
        this.fetchData('all');
    }

    componentWillReceiveProps(nextProps) {
        let clearData = false;
        let isFiltered = false;
        // If initial date range or filter choices change, reset
        if (
            nextProps.startDate !== this.props.startDate ||
            nextProps.endDate !== this.props.endDate ||
            nextProps.offset !== this.props.offset ||
            nextProps.showLoading !== this.props.showLoading
        ) {
            clearData = true;
        }
        if (
            nextProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            nextProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            nextProps.filterType !== this.props.filterType
        ) {
            clearData = true;
            isFiltered = true;
        }
        if (clearData) {
            this.setState({
                allowLocationSelection: true,
                dataIsFiltered: isFiltered,
                dataSet1Complete: false,
                dataSet2Complete: false,
                errorMessageSummary: null,
                errorMessageLocation: null,
                loadingData1: nextProps.showLoading,
                loadingData2: false,
                selectedLocation: {
                    id: null,
                    name: null,
                    dba_name: null,
                    city: null,
                    selected: false,
                    state: null,
                    type: null,
                    zipcode: null
                },
                summariesComplete: false,
                tableSetSummary: [],
                tableSetLocationDaily: [],
                tableSetLocationTotal: [],
                tableSetLocations: []
            });
        }
    }

    componentDidUpdate(prevProps) {
        let dataTypeToFetch = 'none';
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.offset !== this.props.offset ||
            (prevProps.filterType !== 'all' && this.props.filterType === 'all')
        ) {
            dataTypeToFetch = 'all';
        }
        if (
            prevProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            prevProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            prevProps.totalFiltersAvailable !== this.props.totalFiltersAvailable
        ) {
            if (this.props.totalFiltersAvailable === 2) {
                dataTypeToFetch = (this.props.filterChoiceSecond) ? 'filter' : 'none';
            } else if (this.props.totalFiltersAvailable === 1) {
                dataTypeToFetch = 'filter';
            }
        }
        if (dataTypeToFetch === 'filter') {
            if (prevProps.filterType === 'locations') {
                this.fetchLocationsData(this.props.filterChoiceSecond);
            } else {
                this.fetchData(prevProps.filterType);
            }
        } else if (dataTypeToFetch === 'all') {
            this.fetchData('all');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get filtered data by a specific date range or selected Location ID
     *
     * @param dataType
     * @param selectedValue
     */
    fetchData(dataType, selectedValue = null) {
        const params = {
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
        };

        // Update parameters and set resource based on data filter
        let resource;

        let firstFilterValue, secondFilterValue;
        if (dataType !== 'all') {
            if (this.props.filterChoiceFirst) {
                firstFilterValue = this.props.filterChoiceFirst;
            }
            if (this.props.filterChoiceSecond) {
                secondFilterValue = this.props.filterChoiceSecond;
            }
        }
        let dataIsFiltered = (dataType !== 'all');
        let locationId = (this.state.selectedLocation && this.state.selectedLocation.id) ? this.state.selectedLocation.id : null;
        let isLocationData = (dataType === 'selected_location' || dataType === 'location');

        // Do not continue if filter choices are not available due to Primary/Secondary toggling, or if a selection is missing
        if (dataType !== 'all' && !firstFilterValue && !locationId) {
            return;
        }

        // Set additional params and select API path based on data type
        switch (dataType) {
            case 'statecity':
                // Filter: State and City
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = combinedResources.CombinedSalesByStateCity.GET_LIST(params);
                break;
            case 'statedba':
                // Filter: State and DBA
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = combinedResources.CombinedSalesByStateDBA.GET_LIST(params);
                break;
            case 'dba':
                // Filter: DBA
                params.dba_id = firstFilterValue;
                resource = combinedResources.CombinedSalesByDba.GET_LIST(params);
                break;
            case 'district':
                // Filter: District
                params.district_id = firstFilterValue;
                resource = combinedResources.CombinedSalesByDistrict.GET_LIST(params);
                break;
            case 'location':
                // Filter: Location
                locationId = firstFilterValue;
                params.location_id = firstFilterValue;
                resource = combinedResources.CombinedSalesByLocation.GET_LIST(params);
                break;
            case 'selected_location' :
                // Select Location ID in area 1: Retrieve data
                params.location_id = locationId;
                resource = combinedResources.CombinedSalesByLocation.GET_LIST(params);
                break;
            case 'state':
                // Filter: State
                params.state = firstFilterValue;
                resource = combinedResources.CombinedSalesByState.GET_LIST(params);
                break;
            case 'all':
                // Filter: All
                resource = combinedResources.CombinedSalesAll.GET_LIST(params);
                break;
            default:
                // Get all data
                resource = combinedResources.CombinedSalesAll.GET_LIST(params);
                break;
        }

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                if (isLocationData) {
                    // Process results for a selected Location ID
                    this.processLocationData(params.location_id, result.data.payload);
                } else {
                    this.processData(dataType, dataIsFiltered, result.data.payload);
                }
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName;
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName;
            } else {
                console.log('Error', error);
            }
            message += (isLocationData)
                ? ' for Location ' + locationId + '.'
                : '.';
            this.setState({
                dataSet1Complete: true,
                dataSet2Complete: true,
                errorMessageLocation: (isLocationData) ? message : null,
                errorMessageSummary: (isLocationData) ? null : message,
                loadingData1: false,
                loadingData2: false,
                tableLocationDaily: [],
                tableLocationTotals: [],
                tableSetLocations: [],
                tableSetSummary: [],
            }, () => {
                if (typeof this.props.onDataProcessed === 'function') {
                    this.props.onDataProcessed('reports');
                }
            });
        });
    }

    /**
     * Post to get filtered data by data range and array of Location IDs
     *
     */
    fetchLocationsData() {
        const locations = this.props.filterChoiceSecond;
        if (locations && locations.length > 0) {
            let ids = [];
            for (let i = 0; i < locations.length; i++) {
                ids.push(locations[i].id.toString());
            }
            const params = {
                locations: ids,
                fromDay: this.props.startDate,
                toDay: this.props.endDate,
                tz: this.props.offset,
            };
            const resource = combinedResources.CombinedSalesByLocations.UPDATE(params);

            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }

            axios({
                method: resource.type,
                data: params,
                url: resource.uri,
                headers: getPostHeaders()
            }).then((result) => {
                if (result.data && result.data.payload) {
                    this.processData(this.props.filterType, true, result.data.payload);
                }
            }).catch((error) => {
                let message = Config.fuse.error.error + 'Locations for ' + this.state.reportName + '.';
                if (error.response) {
                    // Server response outside 2xx
                    if (error.response.data && error.response.data.error) {
                        message = Config.fuse.error.error + 'Locations for ' + this.state.reportName + ': ' + error.response.data.error;
                    }
                } else if (error.request) {
                    // No response
                    message = Config.fuse.error.no_response + 'Locations for ' + this.state.reportName + '.';
                } else {
                    console.log('Error', error);
                }
                this.setState({
                    dataSet1Complete: true,
                    dataSet2Complete: true,
                    errorMessageSummary: message,
                    loadingData1: false,
                    loadingData2: false,
                    tableLocationDaily: [],
                    tableLocationTotals: [],
                    tableSetLocations: [],
                    tableSetSummary: [],
                }, () => {
                    if (typeof this.props.onDataProcessed === 'function') {
                        this.props.onDataProcessed('reports');
                    }
                });
            });
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Store results
     *
     * @param dataType
     * @param dataIsFiltered
     * @param data
     */
    processData(dataType, dataIsFiltered, data) {

        let tableSetLocations = [];
        let tableSetSummary = [];

        const aggs = JSON.parse(JSON.stringify(data.aggregations));
        if (aggs) {
            // Cycle through data and populate Total Summary
            let totalReturns = (aggs.num_of_credits && aggs.num_of_credits.value) ? aggs.num_of_credits.value : 0;
            let totalSales = (aggs.num_of_payments && aggs.num_of_payments.value) ? aggs.num_of_payments.value : 0;
            let totalTax = (aggs.payment_totals && aggs.payment_totals.total_tax && aggs.payment_totals.total_tax.value) ? aggs.payment_totals.total_tax.value : 0;
            let additionalTax = (aggs.payment_totals && aggs.payment_totals.total_additional_tax && aggs.payment_totals.total_additional_tax.value) ? aggs.payment_totals.total_additional_tax.value : 0;

            tableSetSummary.push({
                returnSubtotal: (aggs.credit_totals && aggs.credit_totals.total_subtotal && aggs.credit_totals.total_subtotal.value) ? aggs.credit_totals.total_subtotal.value * -1 : 0,
                salesAverage: (aggs.avg_net && aggs.avg_net.value) ? aggs.avg_net.value : 0,
                salesGross: (aggs.payment_totals && aggs.payment_totals.total_currency && aggs.payment_totals.total_currency.value) ? aggs.payment_totals.total_currency.value : 0,
                salesNet: (aggs.payment_totals && aggs.payment_totals.total_subtotal && aggs.payment_totals.total_subtotal.value) ? aggs.payment_totals.total_subtotal.value : 0,
                salesTax: totalTax + additionalTax,
                salesAdjusted: (aggs.adj_net && aggs.adj_net.value) ? aggs.adj_net.value : 0,
                totalNet: totalSales - totalReturns,
                totalReturns: totalReturns,
                totalSales: totalSales
            });

            // Cycle through data by Location and populate Location data
            if (aggs.summary_by_location && aggs.summary_by_location.buckets) {
                let lResults = aggs.summary_by_location.buckets;
                for (let i = 0; i < lResults.length; i++) {
                    let lResult = lResults[i];
                    let totalLReturns = (lResult.num_of_credits && lResult.num_of_credits.value) ? lResult.num_of_credits.value : 0;
                    let totalLSales = (lResult.num_of_payments && lResult.num_of_payments.value) ? lResult.num_of_payments.value : 0;
                    let location = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                    tableSetLocations.push({
                        location_id: (location && location.id) ? location.id : '',
                        lot_notes: (location && location.lot_notes) ? location.lot_notes : '',
                        location_name: (location && location.name) ? location.name : '',
                        salesAverage: (lResult.avg_net && lResult.avg_net.value) ? lResult.avg_net.value : 0,
                        salesAdjusted: (lResult.adj_net && lResult.adj_net.value) ? lResult.adj_net.value : 0,
                        state: (location && location.state) ? location.state : '',
                        totalReturns: totalLReturns,
                        totalSales: totalLSales,
                        totalNet: totalLSales - totalLReturns,
                    });
                }
            }
        }

        // Finalize dataset
        this.setState({
            dataSet1Complete: true,
            dataSet2Complete: false,
            loadingData1: false,
            tableSetLocations: tableSetLocations,
            tableSetSummary: tableSetSummary
        }, () => {
            this.assemblePayload();
        });
        if (typeof this.props.onDataProcessed === 'function') {
            this.props.onDataProcessed('reports');
        }
    }

    processLocationData(id, data) {

        // Create empty objects and arrays for selected Location ID
        let location = JSON.parse(JSON.stringify(headerLocationObj));
        let tableLocationDaily = [];
        let tableLocationTotals = [];
        let sortedDaily = [];

        const aggs = JSON.parse(JSON.stringify(data.aggregations));
        if (aggs) {

            // Location Totals
            let totalReturns = (aggs.num_of_credits && aggs.num_of_credits.value) ? aggs.num_of_credits.value : 0;
            let totalSales = (aggs.num_of_payments && aggs.num_of_payments.value) ? aggs.num_of_payments.value : 0;
            let totalTax = (aggs.payment_totals && aggs.payment_totals.total_tax && aggs.payment_totals.total_tax.value) ? aggs.payment_totals.total_tax.value : 0;
            let additionalTax = (aggs.payment_totals && aggs.payment_totals.total_additional_tax && aggs.payment_totals.total_additional_tax.value) ? aggs.payment_totals.total_additional_tax.value : 0;
            tableLocationTotals.push({
                returnSubtotal: (aggs.credit_totals && aggs.credit_totals.total_subtotal && aggs.credit_totals.total_subtotal.value) ? aggs.credit_totals.total_subtotal.value * -1 : 0,
                salesAverage: (aggs.avg_net && aggs.avg_net.value) ? aggs.avg_net.value : 0,
                salesGross: (aggs.payment_totals && aggs.payment_totals.total_currency && aggs.payment_totals.total_currency.value) ? aggs.payment_totals.total_currency.value : 0,
                salesNet: (aggs.payment_totals && aggs.payment_totals.total_subtotal && aggs.payment_totals.total_subtotal.value) ? aggs.payment_totals.total_subtotal.value : 0,
                salesTax: totalTax + additionalTax,
                salesAdjusted: (aggs.adj_net && aggs.adj_net.value) ? aggs.adj_net.value : 0,
                totalNet: totalSales - totalReturns,
                totalReturns: totalReturns,
                totalSales: totalSales
            });

            // Location data (Header)
            if (aggs.column_name && aggs.column_name.hits) {
                let dataPayload = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    location.address = loc.address;
                    location.city = loc.city;
                    location.city_limits = !!(loc.city_limits);
                    location.close_transfer_warehouse = loc.close_transfer_warehouse;
                    // location.dba = {
                    //     name: loc.dba.name
                    // };
                    location.district = {
                        name: loc.district.name
                    };
                    location.id = loc.id;
                    location.latitude = loc.latitude;
                    location.location_type = {
                        name: loc.location_type.name
                    };
                    location.longitude = loc.longitude;
                    location.lot_notes = loc.lot_notes;
                    location.name = loc.name;
                    location.state = loc.state;
                    location.telephone = loc.telephone;
                    location.zipcode = loc.zipcode;
                }
            }

            // Location Daily Sales
            if (aggs.totals_by_day && aggs.totals_by_day.buckets) {
                const keys = Object.keys(aggs.totals_by_day.buckets);
                keys.forEach((key, index) => {
                    const day = aggs.totals_by_day.buckets[key];
                    if (day) {
                        let totalReturns = (day.num_of_credits && day.num_of_credits.value) ? day.num_of_credits.value : 0;
                        let totalSales = (day.num_of_payments && day.num_of_payments.value) ? day.num_of_payments.value : 0;
                        let returnSubtotal = (day.credit_totals && day.credit_totals.total_subtotal && day.credit_totals.total_subtotal.value) ? day.credit_totals.total_subtotal.value * -1 : 0;
                        let salesAverage = (day.avg_net && day.avg_net.value) ? day.avg_net.value : 0;
                        let salesGross = (day.payment_totals && day.payment_totals.total_currency && day.payment_totals.total_currency.value) ? day.payment_totals.total_currency.value : 0;
                        let salesNet = (day.payment_totals && day.payment_totals.total_subtotal && day.payment_totals.total_subtotal.value) ? day.payment_totals.total_subtotal.value : 0;
                        let salesTax = (day.payment_totals && day.payment_totals.total_tax && day.payment_totals.total_tax.value) ? day.payment_totals.total_tax.value : 0;
                        let additionalTax = (day.payment_totals && day.payment_totals.total_additional_tax && day.payment_totals.total_additional_tax.value) ? day.payment_totals.total_additional_tax.value : 0;
                        let salesAdjusted = (day.adj_net && day.adj_net.value) ? day.adj_net.value : 0;
                        // Add Daily row only if values are present
                        if (
                            salesNet !== 0 &&
                            salesAdjusted !== 0
                        ) {
                            tableLocationDaily.push({
                                day: key,
                                returnSubtotal: returnSubtotal,
                                salesAverage: salesAverage,
                                salesGross: salesGross,
                                salesNet: salesNet,
                                salesTax: salesTax + additionalTax,
                                salesAdjusted: salesAdjusted,
                                totalNet: totalSales - totalReturns,
                                totalReturns: totalReturns,
                                totalSales: totalSales
                            });
                        }
                    }
                });
                sortedDaily = sortArrayByKey(tableLocationDaily, 'day', 'DESC');
            }
        }

        // If Filtered by Location, populate the selected Location as if clicked
        let selectedLocation = JSON.parse(JSON.stringify(this.state.selectedLocation));
        if (!selectedLocation.id) {
            selectedLocation.id = location.id;
            selectedLocation.name = location.name;
            selectedLocation.dba_name = location.dba.name;
            selectedLocation.city = location.city;
            selectedLocation.selected = true;
            selectedLocation.state = location.state;
            selectedLocation.type = location.location_type.name;
            selectedLocation.zipcode = location.zipcode;
        }

        // Finalize Item Sales by Location table data
        this.setState({
            allowLocationSelection: true,
            dataSet2Complete: true,
            headerLocation: location,
            loadingData1: false,
            loadingData2: false,
            selectedLocation: selectedLocation,
            tableLocationDaily: sortedDaily,
            tableLocationTotals: tableLocationTotals
        }, () => {
            this.assemblePayload();
        });
    }

    assemblePayload = () => {
        let payload = assembleReportPayload();
        payload.dateRange.fromDay = this.props.startDate;
        payload.dateRange.toDay = this.props.endDate;
        payload.dateRange.tz = this.props.offset;

        // Add Location filtering
        const filterType = this.props.filterType;
        const filterFirst = this.props.filterChoiceFirst;
        const filterSecond = this.props.filterChoiceSecond;
        if (filterType && filterFirst) {
            if (filterType === 'dba') {
                payload.location.dbas.push(filterFirst.toString());
            }
            if (filterType === 'district') {
                payload.location.districts.push(filterFirst.toString());
            }
            if (filterType === 'location') {
                payload.location.locations.push(filterFirst.toString());
            }
            if (filterType === 'state' || filterType === 'statecity' || filterType === 'statedba') {
                payload.location.states.push(filterFirst);
            }
            if (filterSecond) {
                if (filterType === 'statecity') {
                    payload.location.cities.push(filterSecond);
                }
                if (filterType === 'statedba') {
                    payload.location.dbas.push(filterSecond.toString());
                }
            }
        }
        if (filterType && filterType === 'locations' && filterSecond && filterSecond.length > 0) {
            for (let l = 0; l < filterSecond.length; l++) {
                payload.location.locations.push(filterSecond[l].id.toString());
            }
        }
        this.setState({
            payload: payload
        });
    };

    /* Event Handling ------------------------------ */

    /**
     * Store selected Location and make calls
     *
     * @param event
     * @param row
     */
    handleLocationSelect(event, row) {
        const location = {
            id: row.location_id,
            name: row.location_name,
            selected: true,
            state: row.state,
            type: 'selected',
        };
        this.setState({
            allowLocationSelection: false,
            loadingData2: true,
            selectedLocation: location
        }, () => {
            this.scrollToArea(2);
            this.fetchData('selected_location', location.id);
        });
    }

    scrollToArea(area) {
        if (area === 2) {
            window.scrollTo(0, this.area2Position.offsetTop);
        }
    }

    /* Table Collection Display ------------------------------ */

    render() {

        const {
            endDate,
            filterType,
            startDate,
            system,
        } = this.props;

        const {
            allowLocationSelection,
            dataIsFiltered,
            dataSet1Complete,
            dataSet2Complete,
            errorMessageSummary,
            errorMessageLocation,
            headerLocation,
            loadingData1,
            loadingData2,
            payload,
            selectedLocation,
            tableLocationDaily,
            tableLocationTotals,
            tableSetLocations,
            tableSetSummary
        } = this.state;

        const printFile = 'Combined-Sales-Report-' + startDate.replace(/-/g, '') + '-' + endDate.replace(/-/g, '');

        return (
            <div>
                {loadingData1 &&
                    <div className="loader-container">
                        <h4>Generating Reports...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }

                {/* Area 1: Combined Sales Summary and Locations by Date Range and Secondary Filter :::::::::::::::::::::::::::::::::::::::: */}
                <div ref={e => (this.printRef1 = e)}>
                    {dataSet1Complete &&
                        <div>
                            {/* Report Header Set - Summary & Locations */}
                            <div className="report-header">
                                <div>
                                    <div className="btn-print-container report-header-button-container">
                                        <RenderReport
                                            payload={payload}
                                            label="Generate PDF Report"
                                            buttonType="text"
                                            filename={printFile}
                                        />
                                    </div>
                                    <h2 className="report-header-title">All Locations</h2>
                                </div>
                            </div>

                            {/* Table: Combined Sales Summary */}
                            <p style={{margin: '20px 0 0 0'}}>
                                Summary of all location totals
                                from {displayDateRangeString(startDate, endDate, false, 'to')}.
                            </p>
                            <CombinedSalesReportSummaryTable
                                keyStr="Combined-Sales-Summary"
                                title="Summary"
                                listData={tableSetSummary}
                                dataIsFiltered={dataIsFiltered}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />

                            {/* Table: Locations */}
                            <p style={{margin: '20px 0 0 0'}}>
                                Summary of each location total
                                from {displayDateRangeString(startDate, endDate, false, 'to')}.
                            </p>
                            <CombinedSalesReportLocationsTable
                                listData={tableSetLocations}
                                dataIsFiltered={dataIsFiltered}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                                allowLocationSelection={allowLocationSelection}
                                locationIconFunction={this.handleLocationSelect}
                            />
                            <p>
                            </p>
                        </div>
                    }

                    {/* Error and Messaging: Combined Sales Summary and Locations by Date Range and Secondary Filter */}
                    {errorMessageSummary &&
                        <div className="error">
                            <p>{errorMessageSummary}</p>
                        </div>
                    }
                </div>

                {/* Area 2: Selected Location by Date Range and Secondary Filter :::::::::::::::::::::::::::::::::::::::: */}

                <div ref={e => (this.printRef2 = e)}>
                    <div ref={(ref) => this.area2Position = ref}>
                    </div>
                    {selectedLocation.id && loadingData2 &&
                        <div className="loader-container">
                            <h4>Generating Location Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                    }
                    {dataSet2Complete &&
                        <div className="margin-top">

                            {selectedLocation.id && !loadingData2 && tableLocationTotals.length > 0 &&
                                <Fragment>
                                    {/* Report Header Set - Location */}
                                    <div className="report-header">
                                        <div>
                                            {filterType === 'location' &&
                                                <div className="btn-print-container report-header-button-container top">
                                                    <RenderReport
                                                        payload={payload}
                                                        label="Generate PDF Report"
                                                        buttonType="text"
                                                        filename={printFile}
                                                    />
                                                </div>
                                            }
                                            <h2 className="report-header-title">{headerLocation.name}</h2>
                                            <h3 className="report-header-title">
                                                Store
                                                #{headerLocation.id} - {headerLocation.city}, {headerLocation.state}
                                            </h3>
                                            <p>
                                                Report
                                                Date: <strong>{displayDateRangeString(startDate, endDate, false)}</strong>
                                            </p>
                                            <div className="report-header-col-container">
                                                <div className="report-header-col col-6">
                                                    <table className="report-header-table">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan={2}>Location</td>
                                                        </tr>
                                                        <tr>
                                                            <td>ID</td>
                                                            <td>{headerLocation.id}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>{headerLocation.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Address</td>
                                                            <td>{headerLocation.address}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>City</td>
                                                            <td>{headerLocation.city}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>State</td>
                                                            <td>{headerLocation.state}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Zip</td>
                                                            <td>{headerLocation.zipcode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Phone</td>
                                                            <td>{headerLocation.telephone}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>City Limits</td>
                                                            <td>{(headerLocation.city_limits) ? 'True' : 'False'}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Lat/Lon</td>
                                                            <td>{headerLocation.latitude}, {headerLocation.longitude}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="report-header-col col-6">
                                                    <table className="report-header-table">
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan={2}>Location Details</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Close Transfer Warehouse</td>
                                                            <td>{headerLocation.close_transfer_warehouse}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>District</td>
                                                            <td>{headerLocation.district.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Location Type</td>
                                                            <td>{headerLocation.location_type.name}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Table: Location Totals */}
                                    <CombinedSalesReportSummaryTable
                                        keyStr={`Combined-Sales-Location-${selectedLocation.id}-Totals`}
                                        title="Total"
                                        listData={tableLocationTotals}
                                        dataIsFiltered={dataIsFiltered}
                                        endDate={endDate}
                                        startDate={startDate}
                                        system={system}
                                    />

                                    {/* Table: Location Daily Totals */}
                                    <CombinedSalesReportSummaryTable
                                        keyStr={`Combined-Sales-Location-${selectedLocation.id}-Daily`}
                                        title="Daily"
                                        includeDay={true}
                                        listData={tableLocationDaily}
                                        dataIsFiltered={dataIsFiltered}
                                        endDate={endDate}
                                        startDate={startDate}
                                        system={system}
                                    />

                                </Fragment>
                            }
                        </div>
                    }

                    {/* Error and Messaging: Selected Location by Date Range and Secondary Filter */}
                    {errorMessageLocation &&
                        <div className="error">
                            <p>{errorMessageLocation}</p>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

CombinedSalesReportSet.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    filterChoiceFirst: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterChoiceSecond: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterType: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDataProcessed: PropTypes.func,
    startDate: PropTypes.string,
    showLoading: PropTypes.bool,
    system: PropTypes.string,
    totalFiltersAvailable: PropTypes.number,
};

CombinedSalesReportSet.defaultProps = {
    addField: true,
    endDate: null,
    filterChoiceFirst: null,
    filterChoiceSecond: null,
    filterType: 'all',
    offset: null,
    startDate: null,
    showLoading: false,
    totalFiltersAvailable: 0,
};

const enhance = compose(
    connect()
);

export default enhance(CombinedSalesReportSet);



// WEBPACK FOOTER //
// ./src/Fuse/components/CombinedSalesReportSet.js